import { render, staticRenderFns } from "./shareButtons.vue?vue&type=template&id=aa885de6&scoped=true&"
import script from "./shareButtons.vue?vue&type=script&lang=js&"
export * from "./shareButtons.vue?vue&type=script&lang=js&"
import style0 from "./shareButtons.vue?vue&type=style&index=0&id=aa885de6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa885de6",
  null
  
)

export default component.exports